import { PrivateInterceptor } from "../../interceptors/PrivateInterceptor";

export const sendEmail = async (objeto) => {
    const result = await PrivateInterceptor('email/', 'POST', objeto)
    return result;
}
export const sendEmailComunicado = async (objeto, Memo) => {
    const result = await PrivateInterceptor('email/Comunicado', 'POST', {...objeto, Memo})
    return result;
}

export const sendEmailRequisa = async (objeto) => {
    const result = await PrivateInterceptor('email/AprobacionRequisa', 'POST', objeto)
    return result;
}